import { render } from "./CmsDocuments.vue?vue&type=template&id=d0f16d90"
import script from "./CmsDocuments.vue?vue&type=script&lang=js"
export * from "./CmsDocuments.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__